import type { LeaseDisclosures } from 'services/offerAttributesApi'

import { PropertyStatuses } from 'app/sm/helpers'

export const LEASE_DISCLOSURE_RESPONSIBILITIES = {
  tenant: 'tenant',
  landlord: 'landlord',
  notApplicable: 'not_applicable',
} as const

export const isPropertyLive = (propertyStatus?: number | null) =>
  propertyStatus === PropertyStatuses.takingApplications

export const shouldSkipPublishPropertyModal = ({
  requireLeasingDisclosuresBeforePublishing,
  propertyStatus,
}: {
  requireLeasingDisclosuresBeforePublishing: boolean
  propertyStatus?: number | null
}) =>
  !requireLeasingDisclosuresBeforePublishing || isPropertyLive(propertyStatus)

export const isLeaseDisclosuresComplete = (
  leaseDisclosures: LeaseDisclosures = {},
) => {
  const {
    landlord_intends_to_sell,
    water_responsibility,
    electricity_responsibility,
    gas_responsibility,
  } = leaseDisclosures

  const hasIntentToSell = typeof landlord_intends_to_sell === 'boolean'
  const hasWater =
    water_responsibility === LEASE_DISCLOSURE_RESPONSIBILITIES.tenant ||
    water_responsibility === LEASE_DISCLOSURE_RESPONSIBILITIES.landlord
  const hasElectricity =
    electricity_responsibility === LEASE_DISCLOSURE_RESPONSIBILITIES.tenant ||
    electricity_responsibility === LEASE_DISCLOSURE_RESPONSIBILITIES.landlord
  const hasGas =
    gas_responsibility === LEASE_DISCLOSURE_RESPONSIBILITIES.tenant ||
    gas_responsibility === LEASE_DISCLOSURE_RESPONSIBILITIES.landlord ||
    gas_responsibility === LEASE_DISCLOSURE_RESPONSIBILITIES.notApplicable

  return hasIntentToSell && hasWater && hasElectricity && hasGas
}
